import Popup from '../popup';
import i18n from '../../../i18n/i18n';

export default class PopupComponent {
  constructor() {
    this.translator = i18n.translator;
    this.popup = null;
  }

  create(config) {
    this.popup = new Popup(config);
    return this.popup;
  }

  createContentElement(id, template) {
    let content = document.getElementById(id);
    if (!content) {
      content = document.createElement('div');
      content.innerHTML = template;
      content.classList.add('content');
      content.id = id;
      document.body.append(content);
      this.translator.updateUI();
    }
  }

  t(key) {
    return this.translator.translate(key);
  }

  show() {
    if (this.popup) {
      this.popup.show();
    }
  }

  hide() {
    if (this.popup) {
      this.popup.hide();
    }
  }
}
